<template>
    <div class="landing">
        <div class="hero">
            <div class="search-wrapper">
                <div class="title-block animated fadeIn">
                    <h1>
                        Gratis nummerpladetjek
                    </h1>
                    Se bl.a. synsrapporter, restgæld, forsikring, afgifter mv.
                    <!--<br><br>
                    <b>Test nummerplade: AL52114</b>-->
                </div>
                <form action="." @submit.prevent="doSearch()">
                    <input type="search" class="hero-search animated fadeInUp delay-1s" placeholder="AL 52 114" maxlength="9" v-model="licenseplate" ref="tester" />
                    <br><br>
                    <button type="submit" class="animated fadeIn delay-2s">
                        Søg
                    </button>
                </form>
                <div v-if="vehicles.length > 0" class="animated fadeIn delay-5s" @click="goToRandomLicenseplate()">
                    <br>
                    <div style="color:#fff;">eller</div>
                    <br>
                    <div class="random-button">
                        Slå tilfældig nummerplade op
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
@import "../../styles/vars";

    .landing {

        .random-button {
            color: $color--main;
            font-weight: 600;
            cursor: pointer;
            
            &:hover {
                text-decoration: underline;
            }
        }

        .hero {
            // background: linear-gradient(45deg, rgba(40, 60, 134, 0.75), rgba(40, 60, 134, 0.75)), url('https://images.unsplash.com/photo-1492144534655-ae79c964c9d7?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=2894&q=80') center center no-repeat;
            // background: linear-gradient(45deg, rgba(0, 0, 0, 0.75), rgba(0, 0, 0, 0.75)), url('https://images.unsplash.com/photo-1464851707681-f9d5fdaccea8?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=2876&q=80') center center no-repeat;
            background: linear-gradient(45deg, rgba(0, 0, 0, 0.75), rgba(0, 0, 0, 0.75)), url('/static/audi_wide.jpg') center center no-repeat;
            background-size: cover; 
            min-height: 100vh;
            display: flex;
            justify-content: center;
            align-items: center;

            .search-wrapper {
                /* position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%,-50%); */
                padding: 50px 0;
                text-align: center;

                .title-block {
                    color: #fff;
                    margin-bottom: 50px;
                    text-shadow: 0 0 10px rgba(0,0,0,0.7);
                    font-size: 20px;
                    white-space: nowrap;

                    @media screen and (max-width: $medium) {
                        white-space: normal;
                    }

                    h1 {
                        font-size: 70px;
                    }
                }

                button {
                    padding: 15px 45px;
                    font-size: 20px;
                    background: #fff;
                    /* background: linear-gradient(to bottom right, #4256A0, #283C86); */
                    background: $color--main;
                    color: #fff;
                    // border: 1px solid rgba(0, 0, 0, 0.15);
                    border: 1px solid rgba(255, 255, 255, 0.5);
                    border-radius: 100px;
                    transition: .15s ease all;
                    cursor: pointer;
                    text-transform: uppercase;
                    box-shadow: 0px 5px 15px rgba(255, 255, 255, 0.15);

                    &:hover {
                        transform: translateY(-4px);
                        // background: linear-gradient(to bottom right, #283C86, #4256A0);
                        background: darken(rgb(29, 195, 174), 5%);
                    }
                }

                .hero-search {
                    font-size: 75px;
                    padding-bottom: 10px;
                    color: #333;
                    font-family: 'Arial';
                    font-weight: 900;
                    background: url('/static/licenseplate4.png') center center no-repeat;
                    background-size: cover;
                    width: 504px;
                    height: 150px;
                    border: none;
                    padding-left: 85px;
                    padding-right: 30px;
                    text-transform: uppercase;
                    outline: none;
                    text-align: center;

                    &::placeholder {
                        color: rgba(0, 0, 0, 0.1);
                    }
                }
            }
        }
    }

    @media screen and (max-width: $small) {
        .hero-search {
            padding-bottom: 20px !important;
        }
        
        .landing .search-wrapper *:not(button) {
            zoom: 70%;
        }
    }

</style>

<script>
import * as vehicleService from '@/services/vehicle/vehicleService'

export default {
    data () {
        return {
            licenseplate: '',
            vehicles: []
        }
    },
    created () {
        this.getVehicles()
    },
    methods: {
        doSearch () {
            let result = this.licenseplate.split(' ').join('').toUpperCase()
            // this.$router.push({ path: '/?licenseplate=' + result })
            if (result !== '') {
                window.location.href = '/soeg/' + result + '/overblik'
            } else {
                alert('Indtast venligst en nummerplade for at søge.')
            }
        },
        getVehicles () {
            vehicleService.findAll({}, (response) => {
                this.vehicles = response.data
            })
        },
        goToRandomLicenseplate () {
            let min = Math.floor(this.vehicles.length - 100)
            let max = this.vehicles.length
            let randomNumber = Math.floor(Math.random() * (max - min + 1) + min)
            let licenseplate = this.vehicles[randomNumber].lookups[this.vehicles[randomNumber].lookups.length - 1].licenseplate
            window.location.href = '/soeg/' + licenseplate + '/overblik'
        }
    },
    mounted () {
        this.$nextTick(() => this.$refs.tester.focus())
    }
}
</script>




// WEBPACK FOOTER //
// landing.vue?ab7c5b90